import { ResponsiveContainer } from 'recharts';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

export const StyledResponsiveContainer = styled(ResponsiveContainer)<{
  isDark?: boolean;
}>`
  tspan,
  span {
    font-family: Nunito, SF Pro Display, -apple-system, BlinkMacSystemFont,
      Roboto, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji,
      Segoe UI Emoji, Segoe UI Symbol;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.8px;
    text-transform: uppercase;
  }
  tspan {
    fill: ${props =>
      props.isDark ? props.theme.colors.white : props.theme.colors.base.main};
  }
`;
